import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCreditStore } from '@/stores';
import { formatCredits } from '@/utils';
import InstallButton from '@/components/common/InstallButton';

export default function TopBar() {
  const totalBalance = useCreditStore((s) => s.totalBalance);
  const fetchAccount = useCreditStore((s) => s.fetchAccount);

  useEffect(() => {
    fetchAccount();
  }, [fetchAccount]);

  return (
    <header
      role="banner"
      className="fixed top-0 right-0 left-0 z-sticky flex h-14 items-center justify-between border-b border-[rgba(255,255,255,0.08)] bg-[#0f1629] px-4 md:px-6"
    >
      {/* Left: logo */}
      <div className="flex items-center gap-3">
        <span className="font-display text-lg font-bold text-brand-600 select-none">
          OPEX营策
        </span>
      </div>

      {/* Right: install button + credit balance */}
      <div className="flex items-center gap-2">
        <InstallButton />
        <Link
          to="/credits"
          className="flex items-center gap-1 rounded-full bg-[rgba(0,229,255,0.12)] px-2.5 py-1 text-xs font-semibold text-accent-cyan transition hover:bg-[rgba(0,229,255,0.2)]"
          aria-label={`积分余额 ${totalBalance}`}
        >
          <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {formatCredits(totalBalance)}
        </Link>
      </div>
    </header>
  );
}
